// extracted by mini-css-extract-plugin
export default {"middleSection":"bookInformation_middleSection__Kkr0P","description":"bookInformation_description__U9CZO","readmore":"bookInformation_readmore__K9bOv"};